import Service from "./service";
import { ADCU_CHECKER, ADCU_MAKER, ISSUER_ROLE } from "../helpr/constants";

class ReportsService extends Service {

  constructor(unauthorized=false) {
    super("REPORTS_SERVICE", unauthorized);
  }

  // Endpoint to retrieve securities
  getSecurities = () => {
    return this.get('/security');
  }

  getReports = (role, institutionName) => {
    return this.get(`/reports/${role}`, {
      institutionName: institutionName,
      role: role
    });
  }

  sendReport = (isin, reportTitle, reportType, paymentDate, user) => {
    const encodedIsin = encodeURIComponent(isin);
    const encodedReportTitle = encodeURIComponent(reportTitle).replace("(", "%28").replace(")", "%29");
    const encodedReportType = encodeURIComponent(reportType);
    
    // // console.log('user', user);
    return this.patch(`/reports/${encodedReportType}/${encodedIsin}/${encodedReportTitle}/${paymentDate}/maker`, {}, {
      maker: user
    });
  }

  retrieveReport = (reportType, isin, reportTitle, date, folder, fileName, options = {}) => {
    const { bpId, taxAdjustmentType } = options;

    const encodedReportType = encodeURIComponent(reportType);
    const encodedReportTitle = encodeURIComponent(reportTitle).replace("(", "%28").replace(")", "%29");
    const encodedIsin = encodeURIComponent(isin);
    const encodedDate = encodeURIComponent(date);
    const encodedFolder = encodeURIComponent(folder).replace("(", "%28").replace(")", "%29");
    const encodedFileName = encodeURIComponent(fileName).replace("(", "%28").replace(")", "%29");
    if(folder && fileName){
      return this.get(`/reports/${encodedReportType}/${encodedIsin}/${encodedReportTitle}/${encodedDate}`, {
        folder: encodedFolder,
        fileName: encodedFileName
      });
    }
    if (bpId && taxAdjustmentType){
      return this.get(`/reports/${encodedReportType}/${encodedIsin}/${encodedReportTitle}/${encodedDate}`, {}, {
        bpId: bpId,
        taxAdjustmentType: taxAdjustmentType
      });
    }
    console.log(`/reports/${encodedReportType}/${encodedIsin}/${encodedReportTitle}/${encodedDate}`)
    return this.get(`/reports/${encodedReportType}/${encodedIsin}/${encodedReportTitle}/${encodedDate}`);
  }

  retrieveEventBasedReport = (s3Prefix = {}) => {
    const encodedS3Prefix = encodeURIComponent(s3Prefix);

    return this.get(`/reports/event-based/checker`, {s3Prefix: encodedS3Prefix}, {
      s3Prefix: encodedS3Prefix,
    });
  }

  retrieveIssuerAdhocReportFile = (reportType, isin, reportTitle, date, options = {}) => {
    const { bpId, taxAdjustmentType } = options;

    const encodedReportType = encodeURIComponent(reportType);
    const encodedReportTitle = encodeURIComponent(reportTitle).replace("(", "%28").replace(")", "%29");
    const encodedIsin = encodeURIComponent(isin);
    const encodedDate = encodeURIComponent(date);
    return this.get(`/reports/${encodedReportType}/${encodedIsin}/${encodedReportTitle}/${encodedDate}`, {
      bpId: bpId,
      taxAdjustmentType: taxAdjustmentType
    });
  }

  retrieveReportIssuer = (reportType, isin, reportTitle, paymentDate, user, options = {}, bir = {}) => {
    const { bpId, taxAdjustmentType } = options;
    const { birBpId, holder, dateFrom, dateTo } = bir;
    const encodedReportType = encodeURIComponent(reportType);
    const encodedReportTitle = encodeURIComponent(reportTitle).replace("(", "%28").replace(")", "%29");
    const encodedIsin = encodeURIComponent(isin);
    const encodedPaymentDate = encodeURIComponent(paymentDate);
    console.log(birBpId)
    console.log(bir)
    if (bpId && taxAdjustmentType){
      return this.patch(`/reports/${encodedReportType}/${encodedIsin}/${encodedReportTitle}/${encodedPaymentDate}/issuer`, {
        bpId: bpId,
        taxAdjustmentType: taxAdjustmentType
      }, {
        issuer: user
      });
    }
    else if (birBpId && holder && dateFrom && dateTo){
      return this.patch(`/reports/${encodedReportType}/${encodedIsin}/${encodedReportTitle}/${encodedPaymentDate}/issuer`, {
        bpId: birBpId,
        holder: holder,
        dateFrom: dateFrom,
        dateTo: dateTo
      }, {
        issuer: user
      });
    }
    return this.patch(`/reports/${encodedReportType}/${encodedIsin}/${encodedReportTitle}/${encodedPaymentDate}/issuer`, {}, {
      issuer: user
    });
  }

  uploadReport = (reportType, isin, reportTitle, date, fileName, base64File, options = {}) => {
    const { bpId, taxAdjustmentType } = options;
  
    const encodedReportType = encodeURIComponent(reportType);
    const encodedReportTitle = encodeURIComponent(reportTitle).replace("(", "%28").replace(")", "%29");
    const encodedIsin = encodeURIComponent(isin);
    const encodedDate = encodeURIComponent(date);
    const encodedFileName = encodeURIComponent(fileName);
  
    const requestBody = {
      fileData: base64File,
      fileName: encodedFileName,
    };
  
    if (bpId !== undefined && bpId !== null) {
      requestBody.bpId = bpId;
    }
    if (taxAdjustmentType !== undefined && taxAdjustmentType !== null) {
      requestBody.taxAdjustmentType = taxAdjustmentType;
    }
  
    // console.log(`body: `, requestBody);
    // console.log(`/reports/${encodedReportType}/${encodedIsin}/${encodedReportTitle}/${encodedDate}/upload`);
  
    return this.patch(
      `/reports/${encodedReportType}/${encodedIsin}/${encodedReportTitle}/${encodedDate}/upload`,
      { fileName: fileName },
      { body: requestBody }
    );
  };

  uploadEventBasedReport = (reportType, isin, reportTitle, date, fileName, base64File, options = {}) => {
    const { bpId, taxAdjustmentType } = options;
  
    const encodedReportType = encodeURIComponent(reportType);
    const encodedReportTitle = encodeURIComponent(reportTitle).replace("(", "%28").replace(")", "%29");
    const encodedIsin = encodeURIComponent(isin);
    const encodedDate = encodeURIComponent(date);
    const encodedFileName = encodeURIComponent(fileName);
  
    const requestBody = {
      fileData: base64File,
      fileName: encodedFileName,
    };
  
    if (bpId !== undefined && bpId !== null) {
      requestBody.bpId = bpId;
    }
    if (taxAdjustmentType !== undefined && taxAdjustmentType !== null) {
      requestBody.taxAdjustmentType = taxAdjustmentType;
    }
  
    return this.patch(
      `/reports/${encodedReportType}/${encodedIsin}/${encodedReportTitle}/${encodedDate}/upload`,
      { fileName: fileName },
      { body: requestBody }
    );
  };

  makerUploadEventBasedReport = (isin, bpId, reportTitle, issuer, holder, dateFrom, dateTo, paymentDate, file, fileName) => {
    return this.patch(`/reports/event-based/upload`, {}, {
      isin: isin,
      bpId: bpId,
      reportTitle: reportTitle,
      issuer: issuer,
      holder: holder,
      dateFrom: dateFrom,
      dateTo: dateTo,
      paymentDate: paymentDate,
      file: file,
      fileName: fileName
    });
  }

  checkerUploadEventBasedReport = (isin, bpId, reportTitle, issuer, holder, dateFrom, dateTo, paymentDate, file, fileName) => {
    return this.patch(`/reports/event-based/upload`, {}, {
      isin: isin,
      bpId: bpId,
      reportTitle: reportTitle,
      issuer: issuer,
      holder: holder,
      dateFrom: dateFrom,
      dateTo: dateTo,
      paymentDate: paymentDate,
      file: file,
      fileName: fileName
    });
  }
  

    // Endpoint to generate report(CaMaker)
  generateReport = (reportType, reportTitle, isin, paymentDate) => {
    const encodedReportType = encodeURIComponent(reportType);
    const encodedReportTitle = encodeURIComponent(reportTitle).replace("(", "%28").replace(")", "%29");
    const encodedIsin = encodeURIComponent(isin);
    const encodedPaymentDate = encodeURIComponent(paymentDate);
    return this.post(`/reports/${encodedReportType}/${encodedIsin}/${encodedReportTitle}/${encodedPaymentDate}`);
  }

  caMakerSendIssuerAdhocReports = (isin, bpId, reportTitle, taxAdjustmentType, paymentDate, maker) => {
    return this.patch(`/reports/issuer-adhoc/maker/submit`, {}, {
      isin: isin,
      bpId: bpId,
      reportTitle: reportTitle,
      taxAdjustmentType: taxAdjustmentType,
      paymentDate: paymentDate,
      maker: maker
    });
  }

  caCheckerSendIssuerAdhocReports = (isin, bpId, reportTitle, taxAdjustmentType, paymentDate, checker) => {
    return this.patch(`/reports/issuer-adhoc/checker/submit`, {}, {
      isin: isin,
      bpId: bpId,
      reportTitle: reportTitle,
      taxAdjustmentType: taxAdjustmentType,
      paymentDate: paymentDate,
      checker: checker
    });
  }

  checkerSendReport = (reportType, reportTitle, isin, date, user) => {
    const encodedReportType = encodeURIComponent(reportType);
    const encodedReportTitle = encodeURIComponent(reportTitle).replace("(", "%28").replace(")", "%29");
    const encodedIsin = encodeURIComponent(isin);
    const encodedDate = encodeURIComponent(date);
    return this.patch(`/reports/${encodedReportType}/${encodedIsin}/${encodedReportTitle}/${encodedDate}/checker/submit`, {}, {
      checker: user
    });
  }
  
  checkerSendEventBasedReport = (isin, reportTitle, paymentDate, bpId, holder, dateFrom, dateTo, checker = {}) => {
    const encodedReportType = encodeURIComponent("Ad-hoc Reports");
    const encodedReportTitle = encodeURIComponent(reportTitle);
    const encodedIsin = encodeURIComponent(isin);
    const encodedDate = encodeURIComponent(paymentDate);
    const encodedBpId = encodeURIComponent(bpId);
    const encodedHolder = encodeURIComponent(holder);
    const encodedDateFrom = encodeURIComponent(dateFrom);
    const encodedDateTo = encodeURIComponent(dateTo);

    return this.patch(`/reports/${encodedReportType}/${encodedIsin}/${encodedReportTitle}/${encodedDate}/checker/submit`, {}, {
      checker: checker,
      bpId: encodedBpId,
      holder: encodedHolder,
      dateFrom: encodedDateFrom,
      dateTo: encodedDateTo,
    });
  }

  checkerRejectReport = (reportType, reportTitle, isin, date, user, comment, options = {}) => {
    const { bpId, taxAdjustmentType } = options;
    const encodedReportType = encodeURIComponent(reportType);
    const encodedReportTitle = encodeURIComponent(reportTitle).replace("(", "%28").replace(")", "%29");
    const encodedIsin = encodeURIComponent(isin);
    const encodedDate = encodeURIComponent(date);

    if(bpId && taxAdjustmentType){
      return this.patch(`/reports/${encodedReportType}/${encodedIsin}/${encodedReportTitle}/${encodedDate}/checker/reject`, {
        bpId: bpId,
        taxAdjustmentType: taxAdjustmentType
      }, {
        checker: user,
        comment: comment
      });
    }
    
    return this.patch(`/reports/${encodedReportType}/${encodedIsin}/${encodedReportTitle}/${encodedDate}/checker/reject`, {}, {
      checker: user,
      comment: comment
    });
  }
  
  checkerRejectEventBasedReport = (isin, reportTitle, paymentDate, bpId, holder, dateFrom, dateTo, checker, comment = {}) => {
    const encodedReportType = encodeURIComponent("Ad-hoc Reports");
    const encodedReportTitle = encodeURIComponent(reportTitle);
    const encodedIsin = encodeURIComponent(isin);
    const encodedDate = encodeURIComponent(paymentDate);
    const encodedBpId = encodeURIComponent(bpId);
    const encodedHolder = encodeURIComponent(holder);
    const encodedDateFrom = encodeURIComponent(dateFrom);
    const encodedDateTo = encodeURIComponent(dateTo);

    return this.patch(`/reports/${encodedReportType}/${encodedIsin}/${encodedReportTitle}/${encodedDate}/checker/reject`, {}, {
      checker: checker,
      bpId: encodedBpId,
      holder: encodedHolder,
      dateFrom: encodedDateFrom,
      dateTo: encodedDateTo,
      comment: comment
    });
  }

  issuerRequestAdhocReport = (requestDateList) => {
    // console.log(requestDateList)
    return this.patch(`/reports/rr-issuer`, {}, {body: requestDateList});
  }

  issuerGetPaymentDates = (isin) => {
    return this.post(`/security/payment-dates`, {}, {
      isin: isin
    })
  }

  patchTaxExemptApplication = (applicationId, isin, interestPaymentDate, data, confirmed) => {
    var submission = false;
    // console.log(applicationId);
    // console.log(isin);
    // console.log(data);
    // console.log(confirmed);
    if(confirmed === false){
      submission = false;
    }
    return this.patch(`/reports/tax_exempt/${applicationId}`, {}, {
      data: data,
      isin: isin,
      interestPaymentDate: interestPaymentDate,
      submission: confirmed
    })
  }

  retrieveTaxExemptDocumentSubmissionEntry = (applicationId, bpId, interestPaymentDate, reportHash) => {
    return this.get(`/reports/tax_exempt/${applicationId}/${bpId}`, {
      interestPaymentDate: interestPaymentDate,
      reportHash: reportHash}, {
    })
  }

  sellingAgentListSecurities = (email) => {
    // console.log("email: ", email);
    return this.post(`/security-offers`,
      {},
      {email: email}
    )
  }

  workflowRetrieveOtherDocumentsPresignedUrls = (reportType, reportTitle, bpId, date, files) => {
    const encodedReportType = encodeURIComponent(reportType);
    const encodedReportTitle = encodeURIComponent(reportTitle).replace("(", "%28").replace(")", "%29");
    const encodedBpId = encodeURIComponent(bpId);
    const encodedDate = encodeURIComponent(date);
    return this.post(`/reports/${encodedReportType}/${encodedBpId}/${encodedReportTitle}/${encodedDate}/upload/other-documents`, {}, {
      files: files
    }) }

  uploadRequiredDocument = (path, file) => {
    return this.unsignedPut(path, file, {
      headers : {
        'Content-Type' : 'application/pdf'
      }
    })
  }

  removeFiles = (reportType, reportTitle, bpId, date, filePath) => {
    const encodedReportType = encodeURIComponent(reportType);
    const encodedReportTitle = encodeURIComponent(reportTitle).replace("(", "%28").replace(")", "%29");
    const encodedBpId = encodeURIComponent(bpId);
    const encodedDate = encodeURIComponent(date);

    return this.patch(`/reports/${encodedReportType}/${encodedBpId}/${encodedReportTitle}/${encodedDate}/remove`, {}, {
      fileName: filePath
    })
  }

  adcuMakerSubmitReport= (reportHash, interestPaymentDate, maker) => {
    const encodedreportHash = encodeURIComponent(reportHash);
    const encodedDate = encodeURIComponent(interestPaymentDate);
    const encodedmaker = encodeURIComponent(maker);

    return this.patch(`/reports/adcu_maker/submit`, {
      role: ADCU_MAKER
    }, {
      reportHash: encodedreportHash,
      interestPaymentDate: encodedDate,
      maker: encodedmaker
    })
  }
  
  adcuMakerRejectReport = (reportHash, maker, interestPaymentDate, rejectReason) => {
    const encodedreportHash = encodeURIComponent(reportHash);
    const encodedDate = encodeURIComponent(interestPaymentDate);
    const encodedMaker = encodeURIComponent(maker);
    const encodedRejectReason = encodeURIComponent(rejectReason).replace("(", "%28").replace(")", "%29");

    return this.patch(`/reports/adcu_maker/reject`, {}, {
      reportHash: encodedreportHash,
      interestPaymentDate: encodedDate,
      maker: encodedMaker,
      rejectReason: encodedRejectReason
    })
  }

  adcuCheckerSubmitReport= (reportHash, interestPaymentDate, checker) => {
    const encodedreportHash = encodeURIComponent(reportHash);
    const encodedDate = encodeURIComponent(interestPaymentDate);
    const encodedChecker = encodeURIComponent(checker);

    return this.patch(`/reports/adcu_maker/submit`, {
      role: ADCU_CHECKER
    }, {
      reportHash: encodedreportHash,
      interestPaymentDate: encodedDate,
      checker: encodedChecker
    })
  }

  adcuCheckerRejectReport = (reportHash, checker, interestPaymentDate, rejectReason) => {
    const encodedreportHash = encodeURIComponent(reportHash);
    const encodedDate = encodeURIComponent(interestPaymentDate);
    const encodedChecker = encodeURIComponent(checker);
    const encodedRejectReason = encodeURIComponent(rejectReason).replace("(", "%28").replace(")", "%29");

    return this.patch(`/reports/adcu_checker/reject`, {}, {
      reportHash: encodedreportHash,
      interestPaymentDate: encodedDate,
      checker: encodedChecker,
      rejectReason: encodedRejectReason
    })
  }

  issuerAcceptTaxExemptReport = (reportHash, interestPaymentDate, issuer ) => {
    const encodedReportHash = encodeURIComponent(reportHash);
    const encodedDate = encodeURIComponent(interestPaymentDate);
    const encodedissuer = encodeURIComponent(issuer);

    return this.patch(`/reports/issuer/tax-exempt-reports/submit`, {}, {
      reportHash: encodedReportHash,
      interestPaymentDate: encodedDate,
      issuer: encodedissuer
    })
  }

  adcuIssuerRejectReport = (reportHash, issuer, interestPaymentDate, rejectReason) => {
    const encodedreportHash = encodeURIComponent(reportHash);
    const encodedDate = encodeURIComponent(interestPaymentDate);
    const encodedIssuer = encodeURIComponent(issuer);
    const encodedRejectReason = encodeURIComponent(rejectReason).replace("(", "%28").replace(")", "%29");

    return this.patch(`/reports/issuer/tax-exempt-reports/reject `, {}, {
      reportHash: encodedreportHash,
      interestPaymentDate: encodedDate,
      issuer: encodedIssuer,
      rejectReason: encodedRejectReason
    })
  }

  rrMakerGenerateAuditConfirmation = (institutionId, issuerRequestDate, reportType, addressee, address, companyName, designation) => {
    const encodedInstitutionId = encodeURIComponent(institutionId);
    const encodedIssuerRequestDate = encodeURIComponent(issuerRequestDate);
    const encodedReportType = encodeURIComponent(reportType);
    // const encodedAddressee = encodeURIComponent(addressee);
    const encodedAddress = encodeURIComponent(address);
    const encodedCompanyName = encodeURIComponent(companyName);
    const encodedDesignation = encodeURIComponent(designation);

    return this.patch(`/reports/audit-confirmation/rr_maker/generate`, {}, {
    institutionId: encodedInstitutionId,
    issuerRequestDate: encodedIssuerRequestDate,
    reportType: encodedReportType,
    addressee: addressee,
    address: encodedAddress,
    companyName: encodedCompanyName,
    designation: encodedDesignation
    });
  }

  rrMakerSubmitAuditConfirmation = (institutionId, issuerRequestDate, reportType, maker) => {
    const encodedInstitutionId = encodeURIComponent(institutionId);
    const encodedIssuerRequestDate = encodeURIComponent(issuerRequestDate);
    const encodedReportType = encodeURIComponent(reportType);
    const encodedMakerName = encodeURIComponent(maker);

    return this.patch(`/reports/audit-confirmation/rr_maker/submit`, {}, {
    institutionId: encodedInstitutionId,
    issuerRequestDate: encodedIssuerRequestDate,
    reportType: encodedReportType,
    maker: encodedMakerName
    });
  }

  rrCheckerSubmitAuditConfirmation = (institutionId, issuerRequestDate, reportType, checker) => {
    const encodedInstitutionId = encodeURIComponent(institutionId);
    const encodedIssuerRequestDate = encodeURIComponent(issuerRequestDate);
    const encodedReportType = encodeURIComponent(reportType);
    const encodedCheckerName = encodeURIComponent(checker);

    return this.patch(`/reports/audit-confirmation/rr_checker/submit`, {}, {
    institutionId: encodedInstitutionId,
    issuerRequestDate: encodedIssuerRequestDate,
    reportType: encodedReportType,
    checker: encodedCheckerName
    });
  }

  rrCheckerRejectAuditConfirmation = (institutionId, issuerRequestDate, comment, checker) => {
    return this.patch(`/reports/audit-confirmation/rr_checker/reject`, {}, {
      institutionId: institutionId,
      issuerRequestDate: issuerRequestDate,
      comment: comment,
      checker: checker
    });
  }

  requestCertificationOfHoldings = (bpId, dataAsOf, purpose, sellingAgentEmailAddress, sellingAgentEntityId) => {
    const encodedBpId = encodeURIComponent(bpId);
    const encodedDataAsOf = encodeURIComponent(dataAsOf);
    const encodedPurpose = encodeURIComponent(purpose);
    const encodedSellingAgentEmailAddress = encodeURIComponent(sellingAgentEmailAddress);
    const encodedSellingAgentEntityId = encodeURIComponent(sellingAgentEntityId);
    return this.post(`/security-offers/bpId`, {}, {
      bpId: encodedBpId,
      dataAsOf: encodedDataAsOf,
      purpose: encodedPurpose,
      sellingAgentEmailAddress: encodedSellingAgentEmailAddress,
      sellingAgentEntityId: encodedSellingAgentEntityId
    });
  }

  getrequestCertificationOfHoldings = (role, sellingAgentEmailAddress) => {
    const encodedSellingAgentEmailAddress = encodeURIComponent(sellingAgentEmailAddress);
    return this.get(`/reports/certification-of-holdings`, {
      role: role,
      sellingAgentEmailAddress : encodedSellingAgentEmailAddress
    }, {});
  }

  rrMakerGenerateCertificationOfHoldings = (bpId, sellingAgentRequestDate, addressee, address, companyName, designation) => {
    const encodedBpId = encodeURIComponent(bpId);
    const encodedSellingAgentRequestDate = encodeURIComponent(sellingAgentRequestDate);
    const encodedAddress = encodeURIComponent(address);
    const encodedCompanyName = encodeURIComponent(companyName);
    const encodedDesignation = encodeURIComponent(designation);

    return this.patch(`/reports/certification-of-holdings/rr_maker/generate`, {}, {
    bpId: encodedBpId,
    sellingAgentRequestDate: encodedSellingAgentRequestDate,
    addressee: addressee,
    address: encodedAddress,
    companyName: encodedCompanyName,
    designation: encodedDesignation
    });
  }

  rrMakerSubmitCertificationOfHoldings = (bpId, sellingAgentRequestDate, maker) => {
    const encodedBpId = encodeURIComponent(bpId);
    const encodedSellingAgentRequestDate = encodeURIComponent(sellingAgentRequestDate);
    const encodedMakerName = encodeURIComponent(maker);

    return this.patch(`/reports/certification-of-holdings/rr_maker/submit`, {}, {
    bpId: encodedBpId,
    sellingAgentRequestDate: encodedSellingAgentRequestDate,
    maker: encodedMakerName
    });
  }

  rrCheckerSubmitCertificationOfHoldings = (bpId, sellingAgentRequestDate, sellingAgentEmailAddress, comment, checker) => {
    const encodedBpId = encodeURIComponent(bpId);
    const encodedSellingAgentRequestDate = encodeURIComponent(sellingAgentRequestDate);
    const encodedSellingAgentEmailAddress = encodeURIComponent(sellingAgentEmailAddress);
    //const encodedCheckerName = encodeURIComponent(checker);

    return this.patch(`/reports/certification-of-holdings/rr_checker/submit`, {}, {
      bpId: encodedBpId,
      sellingAgentRequestDate: encodedSellingAgentRequestDate,
      sellingAgentEmailAddress: encodedSellingAgentEmailAddress,
      comment: comment,
      checker: checker
    });
  }

  rrCheckerRejectCertificationOfHoldings = (bpId, sellingAgentRequestDate, comment, sellingAgentEmailAddress, checker) => {
    return this.patch(`/reports/certification-of-holdings/rr_checker/reject`, {}, {
      bpId: bpId,
      comment: comment,
      sellingAgentRequestDate: sellingAgentRequestDate,
      sellingAgentEmailAddress: sellingAgentEmailAddress,
      checker: checker
    });
  }

  makerSubmitEventBasedReport = (isin, reportTitle, options, reportDate, file, maker, fileName = "") => {
    const {dateFrom, dateTo, paymentDate, maturityDate} = reportDate
    const { issuer, bpId, holder, address, amount } = options;
    return this.patch(`/reports/event-based/maker`, {}, {
      address: address,
      amount: amount,
      isin: isin,
      reportTitle: reportTitle,
      issuer: issuer,
      bpId: bpId,
      holder: holder,
      dateFrom: dateFrom,
      dateTo: dateTo,
      paymentDate: paymentDate,
      maturityDate: maturityDate,
      maker: maker,
      file: file,
      fileName: fileName
    });
  }

  makerSubmitEventBasedCreditLetterReport = (isin, reportTitle, issuer, paymentDate, address, maker) => {
    return this.patch(`/reports/event-based/maker`, {}, {
      isin: isin,
      reportTitle: reportTitle,
      issuer: issuer,
      paymentDate: paymentDate,
      maker: maker,
      address: address
    });
  }

  makerSubmitEventBasedConsentSolicitationReport = (
    isin, 
    reportTitle,
    issuer,
    address,
    paymentDate,
    amount,
    file, 
    maker,
    fileName = ""
  ) => {
    return this.patch(`/reports/event-based/maker`, {}, {
      isin: isin,
      reportTitle: reportTitle,
      issuer:issuer,
      address: address,
      paymentDate: paymentDate,
      amount: amount,
      file: file,
      maker: maker,
      fileName: fileName
    });
  }
  

  makerGenerateEventBaseReport = (reportTitle, issuer, isin, file ) => {
    console.log(reportTitle);
    console.log(issuer);
    console.log(isin);
    console.log(file);
  }

  caMakerCreateCreditLetter = (isin, reportTitle, securityIssuer, maker, paymentDate, address) => {
    return this.patch(`/reports/corporate_action_payment/credit_letter/create_report`, {}, {
      isin: isin,
      reportTitle: reportTitle,
      securityIssuer: securityIssuer,
      maker: maker,
      paymentDate: paymentDate,
      address: address
    })
  }

  eventBasedReportGetIsinIssuer = () => {
    return this.get(`/isins`, {}, {});
  }

  
}

export default ReportsService;

// Author: Joshua Ian Española
// If any future devs work on the reports module(Which I made with the grace of the Lord Emperor, 
// power of Anime and braking down(not brakedancing), and no experience in AWS)
// and tried to "optimize" the reports api and fail, 
// please increment the counter as a warning to the next guy
//
// hours_wasted_here = 0
//
// If you successfully do it, congrats
// you are a heretic. HERESY
// How dare you tamper the work of the Omnissiah